import styled from "styled-components";

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 50px;
`;

export const ImageItemRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .title {
    color: #444;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const ImageDropzoneWrapper = styled.div`
  width: 100%;
  position: relative;

  aspect-ratio: 1/1;
  border-radius: 15px;
  border: 5px dashed #bebebe;
  opacity: 0.8px;
  background: #fff;
`;

export const DeleteButton = styled.img`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 10;
`;

export const ImageDropInitialContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #444;
  h3 {
    text-align: center;
    font-family: Pretendard;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.165px;
    margin: 20px 0px 7px;
  }
  p {
    color: #838080;
    text-align: center;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;

    margin: 0px;
  }
  svg path {
    fill: rgba(203, 203, 203, 1);
  }
`;
